import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import PresentationListRow from '../../shared/PresentationListRow/presentation.list.row.vue';
import { AxiosPromise } from '../../utils/axios.promise';
import { CommonConfig } from '../../configs/config.common';
import * as T_T from 'cryface';

@Component({
    components: {
        PresentationListRow
    }
})
export default class ListingPresentationList extends Vue {
    public title: string = 'ListingPresentationList';

    public configs = new CommonConfig();

    public reset = true;

    public yonghuId = '';

    public list: any[] = [];

    @Prop({ default: undefined })
    public data: any;

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }

    public reload() {
        this.reset = false;
        this.$nextTick(() => (this.reset = true));
    }

    @Watch('$store.state.lpList.reload', { immediate: true, deep: true })
    public async onPageReload(val: any, oldVal: any) {
        if (T_T.simpleDetect(this.yonghuId)) {
            await this.getList(this.yonghuId);
        }
        // this.reload();
    }

    @Watch('$store.state.auth.userInfo', { immediate: true, deep: true })
    public async onAuthenticated(val: any, oldVal: any) {
        if (T_T.simpleDetect(val)) {
            const yonghuId = val.id;
            this.yonghuId = val.id;
            await this.getList(yonghuId);
        }
    }

    public async getList(yonghuId: any) {
        const apiHost = this.configs.apiHost;
        const fetchedList = await AxiosPromise.get(
            `${apiHost}/agent/listing/presentation/list?yid=${yonghuId}&pageNo=1&pageSize=100`
        );
        // const fetchedList = await AxiosPromise.get(
        //     `http://192.168.0.40:9528/radar-api/agent/listing/presentation/list?yid=${yonghuId}&pageNo=1&pageSize=100`
        // );
        if (fetchedList.errorCode === 200) {
            this.list = fetchedList.data.list.sort((a: any, b: any) => {
                const dtA: any = new Date(a.updateAt);
                const dtB: any = new Date(b.updateAt);
                return dtB - dtA;
            });
        }
    }

    public async mounted() {
    }
}
